import { ApprovedStatus } from '../constants/approvedStatus';
import { ActiveStatus } from '../constants/activeStatus';
import { cloneDeep } from 'lodash';
import { StaticFilters } from '../constants/staticFilters';

const staticKeys = {
  hasInventory: 'has_inventory',
  isApproved: 'has_permissions',
  isRetailerApproved: 'has_permissions',
  assignedToRetailers: 'has_permissions',
  variantHasInventory: 'available_inventory',
  variantIsApproved: 'connected_retailers_count',
  approvedStatus: 'has_retailer_permissions',
  activeProducts: 'active',
  customBuffers: 'variant_inventory_buffer',
};

const checkStaticFilter = (currentFilter, filterKey, yesValue = { $gt: 0 }, noValue = 0) => {
  if (currentFilter[filterKey]) {
    const filterValue = currentFilter[filterKey];
    const key = staticKeys[filterKey];

    if (filterValue.includes('Yes') && !filterValue.includes('No')) {
      return { [key]: yesValue };
    }

    if (!filterValue.includes('Yes') && filterValue.includes('No')) {
      return { [key]: noValue };
    }
  }

  return {};
};

const getPropertiesFilter = (currentFilter, additional = {}) => {
  const propertiesFilter = {
    ...currentFilter,
    ...additional,
  };

  Object.keys(staticKeys).forEach((key) => {
    delete propertiesFilter[key];
  });

  return propertiesFilter;
};

export const getStaticFilters = (currentFilter, additionalFilter = {}) => {
  const filters = {
    ...checkStaticFilter(currentFilter, StaticFilters.HAS_INVENTORY, true, false),
    ...checkStaticFilter(currentFilter, StaticFilters.IS_APPROVED, true, false),
    ...checkStaticFilter(currentFilter, StaticFilters.IS_RETAILER_APPROVED, true, false),
    ...checkStaticFilter(currentFilter, StaticFilters.ASSIGNED_TO_RETAILERS, true, false),
    ...checkStaticFilter(currentFilter, StaticFilters.VARIANTS_HAS_INVENTORY, { $ne: 0 }, { $eq: 0 }),
    ...checkStaticFilter(currentFilter, StaticFilters.VARIANT_IS_APPROVED, { $ne: 0 }, { $eq: 0 }),
    ...checkStaticFilter(currentFilter, StaticFilters.CUSTOM_BUFFERS, { $gte: 0 }, { $lt: 0 }),
    ...getApprovedStatus(currentFilter[StaticFilters.APPROVED_STATUS]),
    ...additionalFilter,
  };
  filters.active = getActiveState(currentFilter.activeProducts);

  return filters;
};

const getApprovedStatus = (approvedStatus) => {
  const filter = {};
  if (approvedStatus) {
    switch (approvedStatus) {
      case ApprovedStatus.NOT_APPROVED:
        filter.has_permissions = false;
        break;

      case ApprovedStatus.PENDING:
        filter.has_permissions = true;
        filter.has_retailer_permissions = false;
        break;

      case ApprovedStatus.SYNCED:
        filter.has_permissions = true;
        filter.has_retailer_permissions = true;
        break;

      default:
        break;
    }
  }
  return filter;
};

const getActiveState = (activeProducts) => {
  return activeProducts === ActiveStatus.ARCHIVED ? 'archived' : 'active';
};

export const staticFilter = (currentFilter, additional = {}) => {
  const additionalFilter = additional.filter ? additional.filter : {};
  const additionalProperties = additional.properties ? additional.properties : {};

  const filter = getStaticFilters(currentFilter, additionalFilter);
  const propertiesFilter = getPropertiesFilter(currentFilter, additionalProperties);

  return {
    filter,
    propertiesFilter,
  };
};

export const stringifyObjectProps = (obj) => {
  const objCopy = cloneDeep(obj);
  Object.entries(objCopy).forEach(([key, value]) => {
    objCopy[key] = JSON.stringify(value);
  });
  return objCopy;
};
